export class RegistrationAppResponse{
	applicationId:string;
	loginId:number;
	applicationStatus:string;
	description:string;
	userDesignation:string;
	strDate:string;
	endDate:string;
	userId:number;
	jeCurrentActionerdeptUserId:number;
	eedeptUserId:number;
	aedeptUserId:number;
	jeUserId:number;
	eeUserId:number;
	adArchiUserId:number;
	ddArchiUserId:number;
	dArchiUserId:number;
	adHortiUserId:number;
	aoAccountUserId:number;
	saoAccountUserId:number;
	otp:string;
}